<template>
  <div class="bfkl">
    <div class="btns__container">
      <el-button size="mini" type="primary" class="plr28" @click="handleAdd"
        >添加</el-button
      >
      <el-button
        size="mini"
        type="primary"
        class="plr28"
        @click="handleDelete"
        plain
        >删除
      </el-button>
    </div>
    <div class="table__container">
      <el-table
        v-loading="tableLoading"
        :data="list"
        height="400"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="nextVisitTime"
          label="拜访日期"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="documentTypeName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="operatorName"
          label="联系人员"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="content"
          label="沟通内容"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="content" label="图片">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrlList"
              style="height: 28px"
              :src="scope.row.imageUrlList.split(',')[0]"
              :preview-src-list="scope.row.imageUrlList.split(',')"
            >
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="98px" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <div class="btn-divide"></div>
            <el-button
              size="mini"
              type="text"
              @click="handleDeleteCause(scope.row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagenation__container">
      <div class="for-fff-bg">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[25, 50, 100, 150, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <add-cause
      v-if="addCauseVisible"
      @cancel="addCauseVisible = false"
      @confirm="handleAddCauseConfirm"
      :projectId="projectId"
    ></add-cause>
    <edit-cause
      v-if="editCauseVisible"
      :detail="causeDetail"
      @cancel="editCauseVisible = false"
      @confirm="handleEditCauseConfirm"
    ></edit-cause>
  </div>
</template>

<script>
import { getPageList, deleteData } from "@/api/salesManagement/bfjl";

import AddCause from "./addBFJL";
import EditCause from "./editBFJL";
export default {
  name: "SalesManagementBFJL",
  props: ["projectId"],
  components: {
    AddCause,
    EditCause,
  },
  data() {
    return {
      form: {
        brand: "",
        model: "",
        shelfNumber: "",
        specification: "",
        useUnit: "",
        supplier: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addCauseVisible: false,
      editCauseVisible: false,
      checkDepartment: false,
      causeDetail: {},
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        projectId: this.projectId,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getPageList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteCause(row) {
      const idList = [row.id];
      this.deleteCause(idList);
    },
    handleCheck(row) {
      this.causeDetail = row;
      this.checkDepartment = true;
    },
    handleEdit(row) {
      this.causeDetail = row;
      this.editCauseVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteData(idList);
    },
    deleteCause(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteData({
            idList,
          });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addCauseVisible = true;
    },
    exportCause() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportCause(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddCauseConfirm() {
      this.addCauseVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditCauseConfirm() {
      this.editCauseVisible = false;
      this.getListData();
    },
  },
};
</script>

<style scoped lang="scss">
.bfkl {
  max-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/bfjl.vue